{
  "titles": {
    "menu": "RVT Rapportages"
  }
}
